// store in React env var instead?
export const SIGN_IN = "https://us-central1-research-bay.cloudfunctions.net/signIn";
export const SIGN_UP = "https://us-central1-research-bay.cloudfunctions.net/signUp";
export const CHECK_TOKEN = "https://us-central1-research-bay.cloudfunctions.net/checkToken";

export const GET_PROFILE = "https://us-central1-research-bay.cloudfunctions.net/getProfile";
export const GET_VIEW_PROFILE = "https://us-central1-research-bay.cloudfunctions.net/getProfileById";
export const SET_PROFILE = "https://us-central1-research-bay.cloudfunctions.net/setProfile";
export const GET_SIGNED_URL = "https://us-central1-research-bay.cloudfunctions.net/getProfileFileSignedUrl";

export const CREATE_POSTING = "https://us-central1-research-bay.cloudfunctions.net/createPosting";
export const UPDATE_POSTING = "https://us-central1-research-bay.cloudfunctions.net/updatePosting";
export const GET_USER_POSTINGS = "https://us-central1-research-bay.cloudfunctions.net/getUserPostings";
export const DELETE_POSTING = "https://us-central1-research-bay.cloudfunctions.net/deletePosting";
export const APPLY_POSTING = "https://us-central1-research-bay.cloudfunctions.net/applyToPosting";

export const GET_CONFIG = "https://us-central1-research-bay.cloudfunctions.net/getConfig";
export const CHANGE_PASSWORD = "https://us-central1-research-bay.cloudfunctions.net/changePassword";
export const DELETE_USER = "https://us-central1-research-bay.cloudfunctions.net/deleteUser";

export const GET_SEARCH = "https://us-central1-research-bay.cloudfunctions.net/getSearch";
export const GET_RECOMMENDATIONS = "https://us-central1-research-bay.cloudfunctions.net/getUserRecommendations";
